import React, { useState, useEffect } from 'react';
import { Table, Input, InputNumber, Form, Typography, message } from 'antd';
import CpProductInfo from '../../components/CpProductInfo';
import send from '../../util/request';

import './style.less';

const EditableCell = ({
  editing,
  dataIndex,
  title,
  inputType,
  record,
  index,
  children,
  ...restProps
}) => {
  const inputNode = inputType === 'number' ? <InputNumber /> : <Input />;
  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item
          name={dataIndex}
          style={{
            margin: 0,
          }}
          rules={[
            {
              required: true,
              message: `请输入 ${title}!`,
            },
          ]}
        >
          {inputNode}
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
};
export default (props) => {
  const [form] = Form.useForm();
  const [tableData, setTableData] = useState([]);
  const [editingKey, setEditingKey] = useState('');
  const [config, setConfig] = useState({ id: '', supplier_id: '' });

  useEffect(() => {
    async function getOrderInformation() {
      const { match: { params: { id } } } = props;
      const { data: { data = {}, code, msg = '' } } = await send({ url: '/ipp/order-purchase/info', params: { id: id } });
      if (+code === 0) {
        const { supplier_id, productInfo = [], is_sap_sync } = data;
        const tableData = productInfo.map(item => ({ ...item, supplier_id, is_sap_sync }));
        setConfig({ id, supplier_id });
        setTableData(tableData);
      } else {
        message.error(msg);
      }
    }

    getOrderInformation(); 
  }, [props]);

  const isEditing = (record) => record.id === editingKey;
  const edit = (record) => {
    form.setFieldsValue(record);
    setEditingKey(record.id);
  };

  const save = async (key) => {
    try {
      const row = await form.validateFields();
      const newData = [...tableData];
      const index = newData.findIndex((item) => key === item.id);

      if (index > -1) {
        const item = newData[index];
        const newItem = { ...item, ...row };
        const { sku_no, sale_unit, project_no, factory, storage_location, weight, batch_no, production_date, number } = newItem;
        const { data: { code, msg } } = await send({
          url: '/ipp/order-purchase/supply',
          method: 'POST',
          data: {
            ...config,
            data: [{ sku_no, sale_unit, project_no, factory, storage_location, weight, batch_no, production_date, number }]
          }
        });
        if (+code === 0) {
          message.success(msg);
          newData.splice(index, 1, newItem);
          setTableData(newData);
          setEditingKey('');
        } else {
          message.error(msg);
        }
      } else {
        newData.push(row);
        setTableData(newData);
        setEditingKey('');
      }
    } catch (errInfo) {
      console.log('Validate Failed:', errInfo);
    }
  };

  const columns = [
    {
      title: '商品',
      dataIndex: 'name',
      width: 300,
      fixed: 'left',
      render(_, record) {
        return (
          <CpProductInfo product={record} />
        );
      }
    },
    {
      title: '收货数量',
      dataIndex: 'number',
      align: 'center',
      width: 80,
      fixed: 'left',
      render(_, record) {
        return (<div>{+record.sale_number}</div>);
      }
    },
    {
      title: '行项目号',
      dataIndex: 'project_no',
      width: 100,
      editable: true,
    },
    {
      title: '工厂',
      dataIndex: 'factory',
      width: 200,
      editable: true,
    },
    {
      title: '库存地点',
      dataIndex: 'storage_location',
      width: 200,
      editable: true,
    },
    {
      title: '收货重量',
      dataIndex: 'weight',
      width: 100,
      editable: true,
    },
    {
      title: '批次',
      dataIndex: 'batch_no',
      width: 100,
      editable: true,
    },
    {
      title: '生产日期',
      dataIndex: 'production_date',
      width: 100,
      editable: true,
    },
    {
      title: '库存状态',
      dataIndex: 'stock_status',
      editable: true,
      align: 'center',
      width: 100,
    },
    {
      title: '操作',
      dataIndex: 'operation',
      align: 'center',
      width: 50,
      fixed: 'right',
      render: (_, record) => {
        const { is_sap_sync } = record || {};
        if (+is_sap_sync !== 0) {
          return <div>-</div>;
        } else {
          const editable = isEditing(record);
          return editable ? (
            <span>
              <Typography.Link
                onClick={() => save(record.id)}
                style={{
                  marginRight: 8,
                }}
              >确定</Typography.Link>
            </span>
          ) : (
            <Typography.Link disabled={editingKey !== ''} onClick={() => edit(record)}>编辑</Typography.Link>
          );
        }

      },
    },
  ];

  const mergedColumns = columns.map((col) => {
    if (!col.editable) {
      return col;
    }

    return {
      ...col,
      onCell: (record) => ({
        record,
        inputType: col.dataIndex === 'age' ? 'number' : 'text',
        dataIndex: col.dataIndex,
        title: col.title,
        editing: isEditing(record),
      }),
    };
  });
  return (
    <Form form={form} component={false}>
      <Table
        className='order-information-form'
        components={{
          body: {
            cell: EditableCell,
          },
        }}
        scroll={{ x: 1800 }}
        rowKey='id'
        dataSource={tableData}
        columns={mergedColumns}
        rowClassName="editable-row"
        pagination={false}
      />
    </Form>
  );
};
